import { render, staticRenderFns } from "./SendNewEmailModal.vue?vue&type=template&id=c6a48d8e&"
import script from "./SendNewEmailModal.vue?vue&type=script&lang=js&"
export * from "./SendNewEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports